package com.wintermar.inspection.feature.util.template_status

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.util.toTitleCase
import com.wintermar.inspection.graphql.type.InspectionTemplateStatus

@Composable
fun InspectionTemplateStatus.toVariant(): TemplateStatusContentModel {
    val themeColor = LocalAppTheme.current.color

    return remember(this, themeColor) {
        when (this) {
            InspectionTemplateStatus.DRAFT -> TemplateStatusContentModel(
                label = this.name.toTitleCase(),
                labelColor = themeColor.text.info.bolder,
                backgroundColor = themeColor.surface.semantic.info.subtle.default,
                borderColor = themeColor.border.info
            )

            InspectionTemplateStatus.PUBLISHED -> TemplateStatusContentModel(
                label = this.name.toTitleCase(),
                labelColor = themeColor.text.success.bolder,
                backgroundColor = themeColor.surface.semantic.success.subtle.default,
                borderColor = themeColor.border.success
            )

            InspectionTemplateStatus.UNKNOWN__ -> TemplateStatusContentModel(
                label = this.name.toTitleCase(),
                labelColor = themeColor.text.default,
            )
        }
    }
}